<template>
    <div class="v-splash" >
        <div class="v-splash__content">
            <div class="v-splash__team v-splash__team--left" :class="{'is-active': animationDone}">
                <div class="v-splash__logo">
                    <img src="@/assets/lsu_tiger.svg" alt="LSU Tigers"/>
                </div>
                <div v-if="$root.game_info.results && $root.game_info.results.length" class="v-splash__score">
                     {{ $root.game_info.results[0].team_score }}
                </div>
            </div>
            <div class="v-splash__animation" :class="{'is-done': animationDone}" @click="$router.push('home')">
                <lottie :options="defaultOptions" v-on:animCreated="handleAnimation"  />
            </div>
            <div class="v-splash__team v-splash__team--right" :class="{'is-active': animationDone}">
                <div class="v-splash__logo">
                    <img src="@/assets/clemson.svg" alt="Clemson"/>
                </div>
                <div v-if="$root.game_info.results && $root.game_info.results.length" class="v-splash__score">
                    {{ $root.game_info.results[0].opponent_score }}
                </div>
            </div>            
        </div>
        <div class="v-splash__footer" :class="{'is-active': animationDone}">
            <div class="v-splash__footer-inner row">
                <div class="v-splash__footer-col v-splash__footer-col--store">
                    <a class="v-splash__footer-link" href="https://www.lsushop.net/?_s=bm-national_champions_splash_page&utm_medium=referral&utm_term=national_champions_embedded"><img class="v-splash__footer-img" src="@/assets/merch_small.jpg" alt="Go to store"/></a>
                </div>
                <div class="v-splash__footer-col v-splash__footer-col--button">
                    <div class="v-splash__hold-button">
                        <HoldButton :text="hold_text" v-on:max_hit="$router.push('home')"/>
                    </div>
                    <div class="v-splash__hold-button-after">
                    </div>
                </div>
                <div class="v-splash__footer-col v-splash__footer-col--site">
                    <a class="v-splash__footer-link v-splash__footer-link--padded" href="https://lsusports.net"><img class="v-splash__footer-img" src="@/assets/LSUsportsnet.svg" alt="Go to LSUsports.net"/></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import Lottie from '@/components/Lottie.vue'
    import * as animationData from '@/assets/animation.json'
    import HoldButton from '@/components/HoldButton.vue'

    export default {
        name: "splash",

        components: {
            'lottie': Lottie,
            HoldButton
        },

        data: () => ({
            anim:false,
            game_content:{},
            defaultOptions: {
                animationData: animationData.default,
                loop:false,
                rendererSettings:{
                    progressiveLoad:true
                }
            },
            animationDone: false,
            hold_text:'Hold to Enter'
        }),

        computed: {
        },

        methods: {
             handleAnimation(anim) {
                this.anim = anim;    
            },
            get_data(){
                if(!this.$root.got_game){
                    let gamePromise =  new Promise((resolve) => {
                         axios.get('/services/schedule_xml_2.aspx?format=json&path=fb&starting=1/11/2020&ending1/15/2020&take=1')
                        .then(response => {
                                let result = response.data.schedule[0];
                                if(result.links.postgame){
                                    this.$root.game_info.links.postgame = result.links.postgame;
                                }
                                if(result.links.boxscore){
                                    this.$root.game_info.links.boxscore = result.links.boxscore;
                                }
                                if(result.results && result.results.length){
                                    this.$root.game_info.results = result.results;
                                }

                                this.$root.got_game = true;
                            resolve();
                        });
                    });
                }
            },

        },

        created() {
            this.get_data();
        },
        mounted() {
            setTimeout(() => this.animationDone=true, 7000);   
        }
    };
</script>

<style lang="scss">
@import "../styles/imports";
html, body{
    overflow:visible !important;
}

@media all and (min-width:$small-breakpoint){
    html, body{
        overflow:hidden !important;
    }
}
</style>

<style lang="scss" scoped>
    @import "../styles/imports";
    .v-splash{
        height:100vh;
        @include flex-container;
        @include flex-column;
        overflow:hidden;
        &__content{
           @include flex-item(1 0 auto);
           @include flex-container;
           @include flex-row;
           @include align-center;
           @include justify-around;
           overflow:hidden;        
        }
        &__animation{
            @include flex-item(0 0 auto);
            width:100%;
            max-width:400px;
            padding:0 48px;
            svg{
                max-width:100%;
            }
            &:hover{
                cursor:pointer;
            }
        }
        &__team{
            @include flex-item(0 1 auto);
            width:50%;
            display:none;
            @include justify-center;
            @include align-center;
            transition:transform 0.8s, opacity 0.8s; 
        }
        &__team--left{
            @include transform(translateX(-25%));
            opacity:0;
            &.is-active{
                @include transform(none);
                opacity:1;
            }
        }
        &__team--right{
            @include transform(translateX(25%));
            opacity:0;
            &.is-active{
                @include transform(none);
                opacity:1;
            }
        }
        &__logo{
            @include flex-item(0 0 auto);
            width:100px;
            margin:0 24px;
        }
        &__score{
            @include flex-item(0 0 auto);
            color: $white;
            font-size:5rem;
            font-weight:700;
            margin:0 24px;
        }
        &__footer{
            flex:0 0 auto;            
            @include transform(translateY(105%));
            transition:transform 0.8s;
            &.is-active{
                @include transform(none);
            }
        }
        &__footer-inner{
            @include flex-container;
            @include flex-column;
            @include align-stretch;
        }
        &__footer-col{
            
            @include flex-item(0 0 auto);
            @include flex-container;
            @include align-center;
            @include justify-center;
            
            &--store{
                @include order(0);
                padding:0 48px;
                img{
                    max-height:124px;
                }
            }
            &--button{
                @include order(2);
                @include flex-column;
                @include justify-start;
                
            }
            &--site{
                @include order(1);
                padding:48px 0;
                img{
                    width:180px;
                }
            }
            
        }
        &__footer-link{
            display:block;            
            &--padded{
                padding:0 48px;
                text-align:center;
                width:100%;
            }
        }
        &__footer-img{
            max-width:100%;
        }
        &__hold-button{
            position:relative;
            @include flex-item(0 0 auto);
            
        }
        &__hold-button-after{
            @include flex-item(0 0 auto);
            width:1px;
            height:60px;
            background:$white;
        }
    }


    @media screen and (min-width:$small-breakpoint){
        .v-splash{
            &__animation{
                width:400px;
                max-width:none;
            }
            &__team{
                @include flex-container;
            }
            &__footer{
                border-top:solid 1px $gray-border;
            }
            &__footer-inner{
                @include flex-row;
            }
            &__footer-col{
                width:33.3333%;
                min-height:calc(100vw * 0.6 * 0.33333 * 0.5625);
                border-right:solid 1px $gray-border;
                &--store{
                    @include align-start;
                    padding:0;
                    img{
                        max-height:none;
                    }
                }
                &--button{
                    @include order(1);
                    padding-bottom:0;
                    padding-top:24px;
                }
                &--site{
                    @include order(2);
                    padding:0;
                    img{
                        width:auto;
                    }
                }
                &:last-child{
                    border-right:none;
                }
            }
            &__footer-link{
                width:100%;
                text-align:right;
                &--padded{
                    text-align:center;
                }
            }
            &__hold-button{

            }
            &__hold-button-after{
                @include flex-item(1 1 auto);
                height:100%;
            }
        }

    }
    @media screen and (min-width: $medium-breakpoint) {
        .v-splash{
            &__animation{
                width:600px;
            }
            &__logo{
                width::120px;
            }
            &__score{
                font-size:7.5rem;
            }
        }
    }
</style>
